import { useCallback, useRef } from 'react';
import { IHandleSetValueParams, TInputState } from '../types';
import { THandleSetValue } from './types';
import { isBoolean, isString } from 'lodash';

export const useHandleSetValue = ({
  inputs,
  setInputs,
}: IHandleSetValueParams): THandleSetValue => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(
    (name: string, srcValue?: TInputState['value']) => {
      const current = inputsRef.current;
      const input = current[name];
      const value = isString(srcValue) && srcValue === '' ? undefined : srcValue;
      if (!input) return;
      const newInput = {
        ...input,
        value,
        touched: isBoolean(value) ? !!input.initialValue !== value : input.initialValue !== value,
        errors: undefined,
      };
      setInputs(prev => ({ ...prev, [name]: newInput }));
    },
    [setInputs]
  );
};
